// Preset themes for tenant branding
export const THEME_PRESETS = [
  { key: "royal_navy", label: "Royal Navy", primary: "#0F172A", accent: "#D4AF37" },
  { key: "emerald_bloom", label: "Emerald Bloom", primary: "#064E3B", accent: "#FBBF24" },
  { key: "crimson_heritage", label: "Crimson Heritage", primary: "#7F1D1D", accent: "#FDE68A" },
  { key: "slate_lux", label: "Slate Lux", primary: "#1E293B", accent: "#14B8A6" },
  { key: "sunset_saffron", label: "Sunset Saffron", primary: "#9A3412", accent: "#FCD34D" },
  { key: "midnight_indigo", label: "Midnight Indigo", primary: "#312E81", accent: "#A78BFA" },
];

export const findTheme = (key) => THEME_PRESETS.find((t) => t.key === key) || THEME_PRESETS[0];
